module.exports = __webpack_public_path__ + "static/media/przemiana6_left.574df51b.jpeg";